import _ from 'lodash';
import Color from 'color';

import Colormap, { ColorArr } from '@scale/shared/colors/colormap';
import { INamedEntityRecognitionLabel as IBaseNamedEntityRecognitionLabel } from '@scale/shared/types/params/namedentityrecognition';

export interface INamedEntityRecognitionLabel extends IBaseNamedEntityRecognitionLabel {
  priority_group?: string;
  priority?: number;
}

export function findLabel(
  labels: INamedEntityRecognitionLabel[],
  name: string,
): INamedEntityRecognitionLabel | null {
  for (const label of labels) {
    if (label.name === name) return label;

    if (label.children) {
      const labelMaybe = findLabel(label.children, name);
      if (labelMaybe) return labelMaybe;
    }
  }

  return null;
}

function getFlattendLabelNames(
  labels: INamedEntityRecognitionLabel[],
  result: string[] = [],
): string[] {
  return _.flatten(
    labels.map(label => {
      if (label.children) {
        return [...getFlattendLabelNames(label.children, result), label.name];
      }

      return [label.name];
    }),
  );
}

export function getColormapForLabels(labels: INamedEntityRecognitionLabel[]) {
  return new Colormap(getFlattendLabelNames(labels));
}

function getPaletteForColor(colorStr: string) {
  const color = Color(colorStr);

  const adjustedColor = color.isLight() ? color.darken(0.5) : color;

  // For label list
  const listItemBackground = adjustedColor.toString();
  const listItemActiveBackground = color.alpha(0.5).toString();
  const listItemHoverredBackground = 'rgb(0, 0, 0, 0.1)';

  const labelUnderline = adjustedColor.alpha(0.6).toString();
  const labelUnderlineFocused = adjustedColor.alpha(adjustedColor.isLight() ? 1 : 0.8).toString();
  const labelUnderlineHoverred = adjustedColor.alpha(0.6).toString();
  const labelUnderlineDisabled = adjustedColor.alpha(0.2).toString();

  const annotationBackgroundActive = adjustedColor.alpha(0.08).toString();

  const linkBackground = adjustedColor.alpha(0.2).toString();

  return {
    original: colorStr,
    listItemActiveBackground,
    listItemHoverredBackground,
    listItemBackground,
    labelUnderlineFocused,
    labelUnderlineHoverred,
    labelUnderlineDisabled,
    labelUnderline,
    annotationBackgroundActive,
    linkBackground,
  };
}

export interface IColorMap {
  ofLabel(label: string): ColorArr[];
}

export function getLabelColorPalette(labelName: string, colorMap: IColorMap) {
  const [r, g, b] = colorMap.ofLabel(labelName)?.[0] || [209, 209, 224];

  return getPaletteForColor(`rgb(${r}, ${g}, ${b})`);
}
